import { Bed, Bath, CookingPot, Flame, Sun } from "lucide-react";
import RoomDetail from "./RoomDetail";
import suiteLiving from "@/assets/suite-living.jpg";
import suiteKitchen from "@/assets/suite-kitchen.jpg";
import suiteBalcony from "@/assets/suite-balcony.jpg";
import suiteStairs from "@/assets/suite-stairs.jpg";
import suiteBedroom from "@/assets/suite-bedroom.jpg";
import suiteSingle from "@/assets/suite-single.jpg";
import suiteFireplace from "@/assets/suite-fireplace.jpg";
import { useLanguage } from "@/i18n/LanguageContext";
import { useRoomContent } from "@/hooks/useRoomContent";

const Suite = () => {
  const { t } = useLanguage();
  const { current } = useRoomContent("suite");
  const rd = t.roomData;
  const images = [
    { src: suiteLiving, alt: current?.title || t.subpageHeroes.suite.title },
    { src: suiteBedroom, alt: "Bedroom" },
    { src: suiteKitchen, alt: "Kitchen" },
    { src: suiteStairs, alt: "Gallery" },
    { src: suiteSingle, alt: "Single Bed" },
    { src: suiteBalcony, alt: "Balcony" },
    { src: suiteFireplace, alt: "Fireplace" },
  ];
  const amenityLabels = current?.amenities?.length ? current.amenities : rd.suite.amenities;
  const amenities = amenityLabels.map((label, i) => ({
    icon: [Bed, Bath, CookingPot, Flame, Sun][i],
    label,
  }));
  return (
    <RoomDetail
      title={current?.title || t.subpageHeroes.suite.title}
      subtitle={current?.description || t.subpageHeroes.suite.subtitle}
      images={images}
      amenities={amenities}
      features={rd.features}
      highlight={{ image: suiteFireplace, title: current?.highlight || rd.suite.highlight, subtitle: current?.highlightSub || rd.suite.highlightSub }}
    />
  );
};

export default Suite;
